import React, { useEffect, useState } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AOS from "aos";
import "aos/dist/aos.css";
import AdminSidebar from "../Side/AdminSidebar";
import { useAuth } from "../Auth/AuthContext";
import Loader from "../Animations/Loader"; // Import your Loader component
import AdsTxtContent from "../AdsTxtConfiguration/AdsTxtContent";

const AdsTxtConfiguration = () => {
    const { authState } = useAuth(); // Get authState from AuthContext
    const role = authState.roles;
    const admin = role === "Admin";
    const [loading, setLoading] = useState(true); // Start with loading state

    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: true, // Animation happens only once
        });

        // Check when the content is ready
        setLoading(false); // Content is ready, hide loader
    }, []);

    if (loading) {
        return <Loader />; // Show loader only when the page is actually loading
    }


    return (
        <div className="mt-6">
            <AdsTxtContent isAdCode={false} />
        </div>
    );
};

export default AdsTxtConfiguration;
